<template>
  <path
    d="M15.6 10.7902C16.57 10.1202 17.25 9.02024 17.25 8.00024C17.25 5.74024 15.5 4.00024 13.25 4.00024H8C7.45 4.00024 7 4.45024 7 5.00024V17.0002C7 17.5502 7.45 18.0002 8 18.0002H13.78C15.85 18.0002 17.74 16.3102 17.75 14.2302C17.76 12.7002 16.9 11.3902 15.6 10.7902ZM10 6.50024H13C13.83 6.50024 14.5 7.17024 14.5 8.00024C14.5 8.83024 13.83 9.50024 13 9.50024H10V6.50024ZM13.5 15.5002H10V12.5002H13.5C14.33 12.5002 15 13.1702 15 14.0002C15 14.8302 14.33 15.5002 13.5 15.5002Z"
  />
</template>
